'use strict';
import angular from 'angular';
var RxCredentialAddController = /** @class */ (function () {
    /*@ngInject*/
    function RxCredentialAddController(Auth, $state, $log, $cookies, $scope, $timeout, Util, RxCredentialAddService, Upload, RxCredentialListService) {
        this.credentialType = null;
        this.credentialTypes = ['License'];
        this.selectedCredentialType = null;
        this.selectedDoctorType = null;
        this.selectedCredential = null;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.prevCredential = null;
        this.showAlert = false;
        this.loadingBar = false;
        this.sameDoctorType = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$log = $log;
        this.$scope = $scope;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.rxCredentialAddService = RxCredentialAddService;
        this.Util = Util;
        this.rxCredentialListService = RxCredentialListService;
        this.sameDoctorType = false;
        var self = this;
        this.currentDate = new Date();
        this.maxDate = new Date("2999-12-31");
        if (self.mode != 'Edit') {
            self.rxCredentialAddService.getRxDoctorTypes().then(function (response) {
                if (response.status == 200 && response.data.errors.length == 0) {
                    self.doctorTypes = response.data.response.currentPage;
                }
            });
            self.credential = {
                id: 1,
                credentialType: 'License',
                doctorType: null,
                licenseNumber: null,
                expirationDate: null,
                file: null,
                status: null
            };
            self.selectedCredentialType = 'License';
        }
        else {
            if (self.credential.credentialType == null) {
                self.credential.credentialType = 'Other';
            }
            self.selectedCredentialType = self.credential.credentialType;
            self.selectedCredential = self.credential;
            self.rxCredentialAddService.getRxDoctorTypes().then(function (response) {
                if (response.status == 200 && response.data.errors.length == 0) {
                    self.doctorTypes = response.data.response.currentPage;
                    self.selectedDoctorType = self.getDoctorType(self.credential.doctorType);
                }
            });
        }
        self.rxCredentialAddService.getRegionsForCountry('US').then(function (response) {
            if (response && response.status == 200 && response.data.errors.length <= 0) {
                self.states = response.data.response.currentPage;
            }
        });
        //$scope.$watch('rxa.files', function() {
        // self.upload(self.selectedCredential);
        //});
        $scope.$watch('rxa.credAddForm.rxaFile.$error.pattern', function () {
            if (self.credAddForm.rxaFile.$error.pattern) {
                self.showAlert = true;
                self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
            }
        });
        Number.prototype.padLeft = function (base, chr) {
            var len = (String(base || 10).length - String(this).length) + 1;
            return len > 0 ? new Array(len).join(chr || '0') + this : this;
        };
        // Listening to the close dialog event and resetting the credit card form
        $scope.$on('addCredentialsFormReset', function (event, data) {
            self.credential = {};
            self.credential.credentialType = 'License'; //ES-3293 to retain cerdential type on add credential dialog close
            $scope.rxa.credAddForm.$setUntouched();
        });
        $scope.$watch('rxa.file', function (newVal, oldVal) {
            if (newVal == oldVal)
                return;
            if (self.file != null) {
                self.showAlert = false;
                if (self.file.size) {
                    var isValidFileType = self.isValidFileType(self.file.type);
                    if (self.file.size > 1000000 || !isValidFileType) {
                        $timeout(function () {
                            $scope.$emit('credentialAddFormValid', false);
                        }, 300);
                        self.showAlert = true;
                        self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
                    }
                    else if (self.areAllFieldsExceptFileUploadValid()) {
                        //self.setCredentialBeforeAdd();
                        $scope.$emit('credentialAddFormValid', true);
                        //self.files = [self.file];
                    }
                }
                else {
                    self.Util.setPageErrors('Cannot upload empty file', '', self);
                    self.showAlert = true;
                }
            }
        });
        $scope.$watch('$viewContentLoaded', function (event) {
            $scope.$watch('rxa.credAddForm.$valid', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (self.file) {
                        $scope.$emit('credentialAddFormValid', newVal);
                    }
                }
            });
        });
        $scope.$watch('rxa.expirationDate', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                if (self.expirationDate != undefined && self.expirationDate != null) {
                    var expDate = new Date(self.expirationDate);
                    var currentDate = new Date(self.currentDate);
                    currentDate.setHours(0, 0, 0, 0);
                    if (typeof expDate == 'object') {
                        if (expDate > self.maxDate || expDate < currentDate) {
                            self.credAddForm.expirationDate.$error.invalid = true;
                            self.credAddForm.expirationDate.$invalid = true;
                            self.credAddForm.expirationDate.$valid = false;
                        }
                        ;
                        if (expDate < self.maxDate && expDate >= currentDate) {
                            self.credAddForm.expirationDate.$error = {};
                            self.credAddForm.expirationDate.$invalid = false;
                            self.credAddForm.expirationDate.$valid = true;
                        }
                    }
                    else {
                        self.credAddForm.expirationDate.$error.invalid = true;
                        self.credAddForm.expirationDate.$invalid = true;
                        self.credAddForm.expirationDate.$valid = false;
                    }
                }
            }
        });
        self.log = '';
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.setCredentialBeforeAdd();
            self.onUpdate({
                $event: {
                    credential: self.credential
                }
            });
            self.resetFormFields();
        });
        $scope.$on('clearForm', function (event, data) {
            self.resetFormFields();
        });
        $scope.$on('AddCredentialError', function (event, data) {
            self.loadingBar = false;
            self.Util.handleApiError(data, self);
            self.restoreFormFields();
        });
        $scope.$on('AddCredentialStarted', function (event, data) {
            self.loadingBar = true;
        });
        $scope.$on('AddCredentialFinished', function (event, data) {
            self.loadingBar = false;
            self.Util.resetApiError(self);
        });
    }
    RxCredentialAddController.prototype.isValidFileType = function (fileType) {
        if (fileType == 'image/png' || fileType == 'image/jpeg' || fileType == 'image/gif' || fileType == 'application/gif' || fileType == 'application/pdf') {
            return true;
        }
        return false;
    };
    RxCredentialAddController.prototype.limitLicenseNum = function (oldLicenseNum, newLicenseNum, length) {
        if (newLicenseNum && newLicenseNum.length > length) {
            this.licenseNumber = oldLicenseNum;
        }
    };
    RxCredentialAddController.prototype.areAllFieldsExceptFileUploadValid = function () {
        if (this.selectedDoctorType != null && this.selectedCredentialType != null &&
            this.licenseNumber != null && this.expirationDate != null && this.credAddForm.expirationDate.$valid && this.state != null && !this.sameDoctorType)
            return true;
        else
            return false;
    };
    RxCredentialAddController.prototype.resetFormFields = function () {
        var self = this;
        self.prevCredential = angular.copy(self.credential);
        self.prevExpirationDate = angular.copy(self.expirationDate);
        self.prevState = angular.copy(self.state);
        self.prevLicenseNumber = angular.copy(self.licenseNumber);
        self.credential.credentialType = 'License'; //ES-3293 to retain cerdential type on form reset
        self.expirationDate = null;
        self.state = null;
        self.licenseNumber = null;
        self.file = null;
        if (self.credAddForm) {
            self.credAddForm.$setPristine();
            self.credAddForm.$setUntouched();
        }
    };
    RxCredentialAddController.prototype.restoreFormFields = function () {
        var self = this;
        self.credential = angular.copy(self.prevCredential);
        self.expirationDate = angular.copy(self.prevExpirationDate);
        self.state = angular.copy(self.prevState);
        self.licenseNumber = angular.copy(self.prevLicenseNumber);
        self.prevCredential = null;
        self.prevExpirationDate = null;
        self.prevState = null;
        self.prevLicenseNumber = null;
    };
    RxCredentialAddController.prototype.setCredentialBeforeAdd = function () {
        var self = this;
        var expDate = self.getExpirationDate(self.expirationDate);
        if (self.file) {
            self.credential.status = 'Upload Pending';
            self.credential.file = self.file;
        }
        self.credential.doctorType = self.selectedDoctorType;
        self.credential.credentialType = self.selectedCredentialType;
        self.credential.licenseNumber = self.licenseNumber;
        self.credential.expirationDate = expDate;
        self.credential.stateIssued = self.state.regionCode;
    };
    RxCredentialAddController.prototype.getDoctorType = function (doctorDescription) {
        for (var i = 0; i < this.doctorTypes.length; i++) {
            if (this.doctorTypes[i].description == doctorDescription) {
                return this.doctorTypes[i];
            }
        }
    };
    RxCredentialAddController.prototype.getExpirationDate = function (expirationDate) {
        var nowDate = new Date();
        var d = new Date(expirationDate);
        var expDate;
        if (d.getHours() == 0 && d.getMinutes() == 0) {
            expDate = d.getFullYear() + '-' + (d.getMonth() + 1).padLeft() +
                '-' + d.getDate().padLeft() + ' ' + nowDate.getHours().padLeft() +
                ':' + nowDate.getMinutes().padLeft() + ':' + nowDate.getSeconds().padLeft() +
                '.' + nowDate.getMilliseconds().padLeft();
        }
        else {
            expDate = d.getFullYear() + '-' + (d.getMonth() + 1).padLeft() +
                '-' + d.getDate().padLeft() + ' ' + d.getHours().padLeft() +
                ':' + d.getMinutes().padLeft() + ':' + d.getSeconds().padLeft() +
                '.' + d.getMilliseconds().padLeft();
        }
        return expDate;
    };
    RxCredentialAddController.prototype.changeCredType = function (credType) {
        var self = this;
        self.selectedCredentialType = credType;
    };
    RxCredentialAddController.prototype.changeDoctorType = function (doctorType, credential) {
        var self = this;
        this.showAlert = false;
        var isDiffDocType = true;
        this.rxCredentialListService.getCredentials().then(function (response) {
            if (response.status == 200 && response.data) {
                var rxCredentialsList = response.data;
                //assuming all approved/pending doctor types should be of same type.
                if (rxCredentialsList.length > 0) {
                    for (var i = 0; i < rxCredentialsList.length; i++) {
                        if (rxCredentialsList[i].status != null && (rxCredentialsList[i].status == "Approved" || rxCredentialsList[i].status == "Pending Review")) {
                            //found approved or pending doctor type
                            if (rxCredentialsList[i].doctorType == doctorType.description) {
                                //found same doctorType, as being entered by user, let user proceed
                                isDiffDocType = false;
                                self.sameDoctorType = false;
                                self.showAlert = false;
                            }
                            break;
                        }
                        if (rxCredentialsList[i].status != null && rxCredentialsList[i].status == "Denied") {
                            isDiffDocType = false;
                        }
                    }
                }
                else {
                    self.sameDoctorType = false;
                    isDiffDocType = false;
                }
            }
            if (isDiffDocType) {
                //found an approved doctor type that does not match user selection, show error
                self.showAlert = true;
                self.sameDoctorType = true;
                self.rxCredentialListService.setValid(false);
                self.Util.setPageErrors('Rx allowance already exists with a different professional designation.', '', self);
            }
            else {
                self.rxCredentialListService.setValid(true);
            }
            self.selectedDoctorType = doctorType;
            self.$scope.$emit('credentialAddFormValid', true);
        });
    };
    RxCredentialAddController.prototype.addCredential = function () {
        this.credential = {
            id: this.credential.length + 1,
            credentialType: null,
            fileName: null,
            status: null
        };
    };
    RxCredentialAddController.prototype.hideRxaCalender = function ($event) {
        var classes = document.getElementsByClassName('_720kb-datepicker-open');
        angular.forEach(classes, function forEachDatepickerPages(value, key) {
            if (classes[key].classList) {
                classes[key].classList.remove('_720kb-datepicker-open');
            }
        });
    };
    /**
     * Create filter function for a query string
     */
    RxCredentialAddController.prototype.createFilterFor = function (query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(state) {
            return (angular.lowercase(state.regionName).indexOf(lowercaseQuery) === 0);
        };
    };
    /**
     * Search for states
     */
    RxCredentialAddController.prototype.querySearch = function (query) {
        var self = this;
        var results = query ? self.states.filter(self.createFilterFor(query)) : self.states;
        return results;
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    RxCredentialAddController.prototype.$onChanges = function (changes) {
        if (changes.credential) {
            this.credential = angular.copy(this.credential);
        }
    };
    return RxCredentialAddController;
}());
export default RxCredentialAddController;
//# sourceMappingURL=rx-credential-add.controller.js.map